"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainId = exports.Network = void 0;
var Network;
(function (Network) {
    Network["mainnet"] = "mainnet";
    Network["rinkeby"] = "rinkeby";
    Network["goerli"] = "goerli";
    Network["binance"] = "binance";
    Network["binanceTestnet"] = "binanceTestnet";
    Network["polygon"] = "polygon";
    Network["arbitrumOne"] = "arbitrumOne";
    Network["arbitrumGoerli"] = "arbitrumGoerli";
    Network["avalanche"] = "avalanche";
    Network["avalancheFuji"] = "avalancheFuji";
    Network["mumbai"] = "mumbai";
    Network["fantom"] = "fantom";
    Network["fantomTestnet"] = "fantomTestnet";
    Network["scrollL1Testnet"] = "scrollL1Testnet";
    Network["scrollL2Testnet"] = "scrollL2Testnet";
    Network["optimism"] = "optimism";
    Network["optimismGoerli"] = "optimismGoerli";
    Network["aurora"] = "aurora";
    Network["auroraTestnet"] = "auroraTestnet";
})(Network = exports.Network || (exports.Network = {}));
var ChainId;
(function (ChainId) {
    ChainId[ChainId["mainnet"] = 1] = "mainnet";
    ChainId[ChainId["rinkeby"] = 4] = "rinkeby";
    ChainId[ChainId["goerli"] = 5] = "goerli";
    ChainId[ChainId["optimism"] = 10] = "optimism";
    ChainId[ChainId["binance"] = 56] = "binance";
    ChainId[ChainId["binanceTestnet"] = 97] = "binanceTestnet";
    ChainId[ChainId["polygon"] = 137] = "polygon";
    ChainId[ChainId["fantom"] = 250] = "fantom";
    ChainId[ChainId["optimismGoerli"] = 420] = "optimismGoerli";
    ChainId[ChainId["fantomTestnet"] = 4002] = "fantomTestnet";
    ChainId[ChainId["arbitrumOne"] = 42161] = "arbitrumOne";
    ChainId[ChainId["arbitrumGoerli"] = 421613] = "arbitrumGoerli";
    ChainId[ChainId["avalanche"] = 43114] = "avalanche";
    ChainId[ChainId["avalancheFuji"] = 43113] = "avalancheFuji";
    ChainId[ChainId["mumbai"] = 80001] = "mumbai";
    ChainId[ChainId["scrollL1Testnet"] = 534351] = "scrollL1Testnet";
    ChainId[ChainId["scrollL2Testnet"] = 534354] = "scrollL2Testnet";
    ChainId[ChainId["aurora"] = 1313161554] = "aurora";
    ChainId[ChainId["auroraTestnet"] = 1313161555] = "auroraTestnet";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
